import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { useLanguage } from '../context/LanguageContext';
import { getContent } from '../content/siteContent';

const About = () => {
  const { language } = useLanguage();
  const content = getContent(language);
  const { about } = content;

  return (
    <div className="bg-vainilla pt-32 pb-20">
      <div className="max-w-6xl mx-auto px-6">
        {/* Hero */}
        <div className="text-center mb-16">
          <h1 className="text-5xl md:text-6xl font-serif text-stone-900 mb-6">{about.hero.headline}</h1>
          <p className="text-xl text-stone-600 max-w-3xl mx-auto leading-relaxed">
            {about.hero.subheadline}
          </p>
        </div>

        {/* Main Content */}
        <div className="grid md:grid-cols-2 gap-12 mb-20">
          <div>
            <img
              src="https://images.unsplash.com/photo-1560113406-36a33855c51e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBmbG93ZXJzfGVufDB8fHx8MTc3MjA0ODE1OHww&ixlib=rb-4.1.0&q=85"
              alt="Margaret Núñez"
              className="w-full h-[600px] object-cover shadow-lg"
            />
          </div>
          <div className="space-y-8">
            <div>
              <h2 className="text-3xl font-serif text-stone-900 mb-4">{about.story.title}</h2>
              <p className="text-stone-600 leading-relaxed">
                {about.story.content}
              </p>
            </div>
            <div>
              <h3 className="text-2xl font-serif text-stone-900 mb-4">{about.philosophy.title}</h3>
              <p className="text-stone-600 leading-relaxed">
                {about.philosophy.content}
              </p>
            </div>
            <div>
              <h3 className="text-2xl font-serif text-stone-900 mb-4">{about.apart.title}</h3>
              <ul className="space-y-3 text-stone-600">
                {about.apart.items.map((item, idx) => (
                  <li key={idx} className="flex items-start">
                    <span className="w-1.5 h-1.5 bg-stone-400 rounded-full mt-2 mr-3 flex-shrink-0"></span>
                    <span>{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Values Section */}
        <div className="bg-cream p-12 mb-20">
          <h2 className="text-4xl font-serif text-stone-900 mb-12 text-center">{about.values.title}</h2>
          <div className="grid md:grid-cols-3 gap-8">
            {about.values.items.map((value, idx) => (
              <div key={idx} className="text-center">
                <h3 className="text-xl font-serif text-stone-900 mb-3">{value.title}</h3>
                <p className="text-stone-600">
                  {value.desc}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* CTA */}
        <div className="text-center bg-cream p-12">
          <h2 className="text-4xl font-serif text-stone-900 mb-6">{about.cta.title}</h2>
          <p className="text-lg text-stone-600 mb-8 max-w-2xl mx-auto">
            {about.cta.content}
          </p>
          <Link to="/contact">
            <Button className="bg-stone-900 text-white hover:bg-stone-800 px-12 py-6 text-lg font-medium rounded-full" data-testid="about-cta-btn">
              {about.cta.button}
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default About;
